import React from 'react';
import {
  Container,
  Row,
  Col,
} from 'react-bootstrap';
import Skeleton from 'react-loading-skeleton';
import Axios from 'axios';
import GitHeaderImage from '../assets/github-header-logo.png';
import PageHeader from '../common/PageHeader';
import './styles/Contributions.css';

// GitHub Icon SVG Component
const GitHubIcon = () => (
  <svg viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 0C5.37 0 0 5.37 0 12c0 5.3 3.44 9.8 8.21 11.39.6.11.82-.26.82-.58v-2.03c-3.34.73-4.04-1.61-4.04-1.61-.55-1.39-1.34-1.76-1.34-1.76-1.09-.75.08-.73.08-.73 1.21.09 1.85 1.24 1.85 1.24 1.07 1.84 2.81 1.31 3.5 1 .11-.78.42-1.31.76-1.61-2.67-.3-5.47-1.33-5.47-5.93 0-1.31.47-2.38 1.24-3.22-.12-.3-.54-1.52.12-3.18 0 0 1.01-.32 3.3 1.23a11.5 11.5 0 0 1 6 0c2.29-1.55 3.3-1.23 3.3-1.23.66 1.66.24 2.88.12 3.18.77.84 1.24 1.91 1.24 3.22 0 4.61-2.8 5.63-5.48 5.92.43.37.81 1.1.81 2.22v3.29c0 .32.22.69.82.58C20.56 21.8 24 17.3 24 12 24 5.37 18.63 0 12 0z"/>
  </svg>
);

// Loading Component with modern design
const LoadingComponent = () => (
  <div className="loading-card">
    <div className="loading-content">
      <Skeleton className="loading-icon" />
      <div className="loading-details">
        <Skeleton width={200} height={20} style={{ marginBottom: '0.5rem' }} />
        <Skeleton count={2} height={16} />
      </div>
    </div>
  </div>
);

// Modern Repository Card Component
const GitRepoDetailsComponent = ({ name, description, link }) => (
  <div className="repo-card">
    <div className="repo-content">
      <div className="repo-icon">
        <GitHubIcon />
      </div>
      <div className="repo-details">
        <a href={link} target="_blank" rel="noopener noreferrer" className="repo-name">
          {name}
        </a>
        <p className="repo-description">
          {description || 'No description available'}
        </p>
      </div>
    </div>
  </div>
);

// Floating decorative elements
const FloatingElements = () => (
  <div className="floating-elements">
    <div className="floating-element">
      <GitHubIcon />
    </div>
    <div className="floating-element">
      <GitHubIcon />
    </div>
    <div className="floating-element">
      <GitHubIcon />
    </div>
  </div>
);

class Contributions extends React.Component {
  constructor() {
    super();
    this.state = { gitrepos: [], loading: true }
  }

  componentDidMount() {
    Axios.get('https://api.github.com/users/chandu1310/starred')
      .then(response => {
        // Add a delay for better UX to show the loading animation
        setTimeout(() => {
          this.setState({ 
            gitrepos: response.data.slice(0, 6), // Limit to 6 repos for better display
            loading: false 
          });
        }, 1500);
      })
      .catch(error => {
        console.error('Error fetching repositories:', error);
        setTimeout(() => {
          this.setState({ loading: false });
        }, 1500);
      });
  }

  render() {
    const { gitrepos, loading } = this.state;
    
    let GitRepos;
    if (loading) {
      GitRepos = Array(3).fill(0).map((_, index) => (
        <LoadingComponent key={index} />
      ));
    } else {
      GitRepos = gitrepos.map(repo => (
        <GitRepoDetailsComponent 
          key={repo.id} 
          name={repo.name} 
          description={repo.description} 
          link={repo.html_url} 
        />
      ));
    }

    return (
      <>
        <PageHeader title="Contributions" />
        <section className="contributions-section">
          <FloatingElements />
          <Container className="contributions-container">
            <Row>
              <Col>
                <p className="contributions-subtitle">
                  Giving back to the developer community through open source
                </p>
              </Col>
            </Row>
          
          <Row>
            <Col lg={5} className="mb-4">
              <div className="quote-section">
                <p className="quote-text">
                  As once Albert Einstein said:
                </p>
                <div className="quote-highlight">
                  "Make everything as simple as possible, but not simpler."
                </div>
                <p className="quote-text">
                  Much inspired by his works and intelligence, I always strive to give back to the community.
                  My open source contributions reflect my belief in creating code that makes solutions more accessible and elegant.
                </p>
                <p className="quote-text">
                  Most of my work around Node.js and Java programming is readily available on GitHub and npm.
                  Here are some notable repositories I've created and contributed to.
                </p>
              </div>
            </Col>
            
            <Col lg={7}>
              <div className="repos-section">
                <div className="github-header">
                  <img
                    width={150}
                    height={58}
                    src={GitHeaderImage}
                    alt="GitHub"
                  />
                  <h3 className="github-header-title">Featured Repositories</h3>
                </div>
                {GitRepos}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      </>
    );
  }
}

export default Contributions;